import React from 'react';
import {
    HeaderText,
    SubHeaderText,
    BenefitsList,
    FeeText,
    SignUpPrompt,
    CreditCardText
} from '../Landing.styles';

const LandingIntroduction = () => {
  return (
    <>
        <HeaderText variant="h5">
            Dental Temping & Hiring Done Right.
        </HeaderText>

        <SubHeaderText variant="body1">
            Connecting dental offices with top dental professionals. Over 170,000 temping shifts completed since 2015.
        </SubHeaderText>

        <BenefitsList component="ul">
            <li>No subscriptions</li>
            <li>No hourly rate mark-ups</li>
            <li>Free for dental professionals</li>
        </BenefitsList>

        <FeeText variant="body1">
            Small per-placement fee for offices, charged only after successful placement.
        </FeeText>

        <SignUpPrompt variant="h6">
            Sign up for free <CreditCardText>no credit card needed</CreditCardText>
        </SignUpPrompt>
    </>
  )
}

export default LandingIntroduction
